import GeneralFactory from 'coreClasses/GeneralFactory';
import AbstractLogProvider from './providers/AbstractLogProvider';
import SFCCLogger from './providers/sfcc/SFCCLogger';

/**
 * Represents LogProvidersFactory
 */
class LogProvidersFactory extends GeneralFactory {
	/**
	 * Creates log provider
	 * @param {string} providerName - provider name
	 * @returns {AbstractLogProvider} - log provider
	 */
	create(providerName: string): AbstractLogProvider|null {
		switch (providerName) {
			case 'sfcc':
				return new SFCCLogger(this.managerRepository.getCommerceApi());
			default:
				return null;
		}
	}
}

export default LogProvidersFactory;
